<!-- <div id="hoverTipID" *ngIf="bShowHoverTip" hoverTip #hoverTip>{{hoverVal}}</div> -->
<div class="margin-top-sm">

    <div class="floatCreate">
        <button mat-raised-button matTooltip="Create new school district" [disabled]="!bAllowCreate"
            (click)="fnCreate()" class="btnRaise" color="primary" *ngIf="featurePermissions['Create Schools']">
            <ng-container *ngIf="!bCancelCreate">
                <mat-icon class="iconDisplay">edit</mat-icon>
            </ng-container>&nbsp;{{createBtnText}}
        </button>
    </div>
    <div class="row">
        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <div style="margin-top: 15px;">
                <form [formGroup]="formCtlSelectSchool" class="formSelectSchool">
                    <mat-form-field style="width:100%;">
                        <mat-label>
                            Filter
                        </mat-label>
                        <input id="txtFilter" type="text" matInput type="text" formControlName="txtFilter" name="txtFilter"
                            placeholder="{{filterPlaceholder}}" (keyup)="applyFilter($event)" #input>
                    </mat-form-field>
                </form>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 buttonWrapper">
            <button mat-raised-button color="secondary" aria-label="Clear" (click)="fnReset()" [disabled]="!canClearFilter"
                matTooltip="Clear filter">
                <i class="material-icons">
                    <span class="material-icons make-white">delete_forever</span></i>
            </button>
        </div>
    </div>

    <h2>{{txtSearchResultsTitle}}</h2>
    <mat-table [dataSource]="tableDataSource" class="table-responsive" matSort
        (matSortChange)="announceSortChange($event)">

        <ng-container *ngIf="showViewIcon" matColumnDef="selectView">
            <th class="midHeader" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                <ng-container *ngIf="showViewIcon">
                    <span class="raiseEditIcon">
                        <button mat-icon-button color="primary" (click)="openDialog(element)" matTooltip="View School"
                            [matTooltipPosition]="position.value!">
                            <!-- [ngClass]="(fnGetStatusID(results[i].SCHOOL_STATUS) == 2)? 'make-red' : ''" matTooltipHideDelay="100000" [matTooltipPosition]="position.value" #tooltip="matTooltip" -->
                            <mat-icon style="transform: translateX(-4px);">remove_red_eye</mat-icon>
                        </button></span>
                    <span class="raiseEditIcon">
                        <button *ngIf="featurePermissions['Edit Schools']" mat-icon-button color="primary"
                            (click)="edit(element)" matTooltip="Edit School" [matTooltipPosition]="position.value!">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </span>
                </ng-container>

                <span *ngIf="results[i]?.ID" [hidden]="bHideColID">R: {{results[i]?.ID ?? ""}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="REGIONS.CODE">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> Region
            </th><!--width:80px;-->
            <td class="flushUpHovers" mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                <!-- [class.row-is-clicked]="fnCheckRow(element,i)" <div id="hoverContainer" (mouseover)="onFocus($event, element.REGIONS.NAME, 1)"  (mouseout)="onBlur($event, 1)"> -->
                <button mat-icon-button color="primary" (mouseover)="onFocus($event, element.REGIONS.NAME, 1)"
                    matTooltip="{{customHoverMessage}}" [matTooltipPosition]="position.value!">
                    <span style='font-size:large;'>{{element.REGIONS?.CODE}}</span>
                </button>

                <!-- </div> -->
            </td>
        </ng-container>

        <ng-container matColumnDef="COUNTy.COUNTY_CODE">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> County
            </th><!-- width:80px;-->
            <td class="flushUpHovers" mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                <!-- [class.row-is-clicked]="fnCheckRow(element,i)" <div id="hoverContainer2" (mouseover)="onFocus($event, element.COUNTy.COUNTY_NAME, 2)"  (mouseout)="onBlur($event, 2)"> -->
                <button mat-icon-button color="primary" (mouseover)="onFocus($event, element.COUNTy.COUNTY_NAME, 1)"
                    matTooltip="{{customHoverMessage}}" [matTooltipPosition]="position.value!">
                    <span style='font-size:large;'>{{element.COUNTy?.COUNTY_CODE}}</span>
                </button>
                <!-- </div> -->
            </td>
        </ng-container>

        <ng-container matColumnDef="{{columnList[3] | uppercase}}">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;">
                {{columnList[3] | titlecase}} </th>
            <td mat-cell *matCellDef="let element;let i = index" class="flushUp"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                <!-- [class.row-is-clicked]="fnCheckRow(element,i)"-->
                <textarea rows="2" cols="10"
                    [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-text-area-red' : 'make-text-area'"
                    readonly="true" style="border:1px;resize:none;bottom:0;vertical-align:bottom;"
                    autocomplete="off"> {{element.DISTRICT}} </textarea>
            </td>
        </ng-container>

        <ng-container matColumnDef="NAME"><!--{{columnList[4] | uppercase}}-->
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:40px;"> School Name
            </th>
            <!-- <span class="fa fa-fw" ng-class="{ 'fa-sort':currentSortValue != 'NAME' ,'fa-chevron-up':!reverse && currentSortValue === 'NAME', 'fa-chevron-down':reverse && currentSortValue === 'NAME' }"></span> -->
            <td class="flushUp" mat-cell *matCellDef="let element; let i = index;"
                [class.row-is-clicked]="fnCheckRow(element,i)"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                {{element.NAME | titlecase}}
            </td>
        </ng-container>

        <ng-container matColumnDef="STREET_1">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> Address
            </th>
            <td mat-cell *matCellDef="let element; let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">

                {{fnFormatPostalAddress(element.ORGANIZATION)}}
                <br>
                {{fnFormatMailingAddress(element.ORGANIZATION)}}


            </td>
        </ng-container>

        <ng-container matColumnDef="{{columnList[6] | uppercase}}">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;">
                {{columnList[6]}} </th>
            <td class="flushUp" mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''"
                [class.row-is-clicked]="fnCheckRow(element,i)">
                {{element.PHONE.length > 0 ? 'W: '+ element.PHONE : ''}}
            </td>
        </ng-container>

        <ng-container matColumnDef="cdscODE">
            <!-- {{columnList[7]}}  [class.row-is-clicked]="fnCheckRow(element,i)"-->
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:40px;"> CDS Code
            </th>
            <td class="flushUp" mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                {{element.cdscODE}}
            </td>
        </ng-container>

        <ng-container matColumnDef="SCHOOL_STATUS.SCHOOL_STATUS_TYPES_ID">
            <th class="midHeader" mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:20px;"> Status</th>
            <td class="flushUp" mat-cell *matCellDef="let element;let i = index"
                [ngClass]="(fnGetStatusID(element.SCHOOL_STATUS) == 2)? 'make-red' : ''">
                <!--  [class.row-is-clicked]="fnCheckRow(element,i)"-->
                {{fnFormatStatus(element.SCHOOL_STATUS?.SCHOOL_STATUS_TYPES_ID)}}
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let i = index; let row; columns: displayedColumns;"></tr>
    </mat-table>
</div>
<mat-paginator style="width:100%;" #myPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
    aria-label="Select page">
</mat-paginator>